import { Capacitor } from '@capacitor/core'
import { CapPlatform } from '../../interfaces/platform/Platform'

export const platform = Capacitor.getPlatform() as CapPlatform
